import React, { Component } from 'react'
import LoginForm from './components/LoginForm'
import { connect } from 'react-redux'
import { loginUser, forgotPassword } from './redux/authActions'
import { Container, Row } from 'reactstrap'
import CustomHelmet from '../../common/CustomHelmet'

import './index.css'

class index extends Component {
  render() {
    let fromPathname = '/'
    if (this.props.location.state && this.props.location.state.fromPathname) {
      fromPathname = this.props.location.state.fromPathname
    }
    return (
      <div className='app flex-row align-items-center'>
        <CustomHelmet title='Login' />
        <Container>
          <Row className='justify-content-center'>
            <LoginForm
              loginUser={this.props.loginUser}
              forgotPassword={this.props.forgotPassword}
              auth={this.props.auth.isAuthenticated}
              errors={this.props.errors}
              fromPathname={fromPathname}
            />
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
})

export default connect(mapStateToProps, { loginUser, forgotPassword })(index)
